import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConsts } from '@shared/AppConsts';
import { FileDto } from '@shared/service-proxies/service-proxies';
import { downloadWithAuth } from '@shared/utils/authenticated-download';

@Injectable()
export class FileDownloadService {

    constructor(private _httpClient: HttpClient) {
    }

    downloadTempFile(file: FileDto) {
        const url = AppConsts.remoteServiceBaseUrl + '/File/DownloadTempFile?fileType=' + encodeURIComponent(file.fileType) + '&fileToken=' + encodeURIComponent(file.fileToken) + '&fileName=' + encodeURIComponent(file.fileName);
        // /File/DownloadTempFile requires authentication, so send the bearer token instead of navigating.
        downloadWithAuth(this._httpClient, url, file.fileName);
    }
}
